/** API url */
export const API_URL = {
  /** 初始化信息 */
  INIT: '/v1/init/start',
  /** 获取文档信息 */
  GET_PUBLISH_INFO: '/v2/document/s-get-info',
  /** 获取初始化数据信息 GET|POST */
  GET_WATCH_INFO: '/v2/document/s-get-watch-info',
  /** 重置文档信息 */
  RESET: '/v2/document/s-reset-watch-info',
  /** 发消息 GET|POST */
  SEND_MESSAGE: '/v2/message/s-send',
  /** 断线重推消息  ims2 */
  REPUBLISH: '/v2/message/s-send-special',
  /** 活动总的开启消息  log-vhallyun-lss */
  START: '/room/lss-log',
  /** 获取某个文档的章节 */
  GET_CHAPTERS: '/v2/document/s-get-chapters',
  /** 文档章节消息发送接口 */
  SEND_CHAPTERS: '/v2/document/s-chapter-message-send'
};

export const KV = {
  APP_ID: 'app_id',
  CHANNEL_ID: 'channel_id',
  ROOM_ID: 'room_id',
  DOC_ID: 'docId',
  THIRD_PARTY_USER_ID: 'third_party_user_id',
  ACCESS_TOKEN: 'access_token',
  PACKAGE_CHECK: 'package_check',
  CLIENT: 'client',
  VFID: 'vfid',
  BU: 'bu',
  ROLE: 'role',
  ROOT_ELEMENT: 'root_element',
  ROOT_WIDTH: 'root_origin_width',
  ROOT_HEIGHT: 'root_origin_height',
  DOCUMENT_URL_BASE: 'document_url_base',
  UPLOAD_IMAGE_BASE: 'upload_image_base',
  BOARD_BACKGROUND_COLOR: 'board_background_color',
  IS_VOD: 'is_vod',
  WATCH_ON: 'watch_on',
  CURRENT_DOC_CID: 'current_doc_cid',
  DOCUMENT_SERVER: 'document_server',
  SOCKET_INSTANCE: 'socket_instance',
  /** 播放模式， 分为，互动，flv，hls 对应延时，低中高 */
  PLAY_MODE: 'play_mode',
  // 播放器延时，与PLAY_MODE参数互斥。优先播延时参数
  PLAY_DELAY: -1,
  PERMISSION: 'permission',
  IS_CACHE: 'is_cache', // 是否缓存，send接口使用 默认值为1 ，缓存，0，不缓存
  ISRELAY: 'isRelay', // 是否为转播
  ISVODRECORD: 'isVodRecord', // 是否为外界自定义 curpoint.msg 回放模式
  CHAPTERS: 'chapters', // 章节key
  FORCE_DOC_TYPE: 'force_doc_type' // 强制演示某格式文档
};

export const GRAPHIC = {
  /** 取消画笔 */
  CANCEL: -1,
  /** 自由画笔 */
  PEN: 1,
  /** 荧光笔 */
  NITE_WHITE_PEN: 2,
  /** 方块 */
  SQUARE: 3,
  /** 圆形 */
  CIRCLE: 4,
  /** 文本 */
  TEXT: 6,
  /** 图片 */
  BITMAP: 7,
  /** 等腰三角形 */
  ISOSCELES_TRIANGLE: 8,
  /** 直角三角形 */
  RIGHT_TRIANGLE: 9,
  /** 直线 */
  LINE: 10,
  /** 单箭头 */
  SINGLE_ARROW: 11,
  /** 双箭头 */
  DOUBLE_ARROW: 12
};

export const CONTAINER_TYPE = {
  /** 文档类型 */
  DOCUMENT: 'document',
  /** 白板类型 */
  BOARD: 'board'
};

/** 角色类型，目前可想到的有4种，房主、嘉宾、普通观众、助理，且顺序还不确定，后期可能调整 */
export const ROLE_TYPE = {
  /** 房主 */
  HOST: 1,
  /** 嘉宾 */
  GUEST: 2,
  /** 普通观众 */
  SPECTATOR: 3,
  /** 助理 */
  ASSISTANT: 4
};

export const SDK_EVENT = {
  /** 全局错误 */
  ERROR: 'VH_DOC_SDK_ERROR',
  /** 翻页 */
  PAGE_CHANGE: 'VH_DOC_SDK_PAGE_CHANGE',
  /** 文档缩放比例触发事件 */
  SCALE_TRIGGER: 'VH_DOC_SDK_SCALE_TRIGGER',
  /** 创建容器事件 */
  CREATE_CONTAINER: 'VH_DOC_SDK_CREATE',
  /** 删除容器事件 */
  DELETE_CONTAINER: 'VH_DOC_SDK_DELETE',
  /** 选择容器事件 */
  SELECT_CONTAINER: 'VH_DOC_SDK_SELECT',
  /** 重置容器事件 */
  RESET_CONTAINER: 'VH_DOC_SDK_RESET',
  /** 观看端演示状态变更事件 */
  SWITCH_CHANGE: 'VH_DOC_SDK_SWITCH_CHANGE',
  /** 文档加载完成 */
  DOCUMENT_LOAD_COMPLETE: 'VH_DOC_SDK_DOC_LOAD_COMPLETE',
  /** 所有文档加载完成 */
  ALL_COMPLETE: 'ALL_COMPLETE',
  /** 文档不存在或者被删除事件 **/
  DOCUMENT_NOT_EXIT: 'DOCUMENT_NOT_EXIT',
  /** 回放文档容器 */
  VOD_TIME_UPDATE: 'VH_DOC_SDK_VOD_TIME_UPDATE',
  /** cuepoint 文件加载完成 */
  VOD_CUEPOINT_LOAD_COMPLETE: 'VH_VOD_CUEPOINT_LOAD_COMPLETE',
  /** 回放数据可用了 */
  VOD_CUEPOINT_USEABLE: 'VH_VOD_CUEPOINT_USEABLE',
  /** ppt播放完毕事件 */
  PLAYBACKCOMPLETE: 'PLAYBACKCOMPLETE',
  /** 页码、步数、每步时间集合 */
  ANIMATIONINFO: 'ANIMATIONINFO',
  /** 文档章节事件 */
  SINGLE_CHAPTERS: 'SINGLE_CHAPTERS',
  /** 流媒体重制回放准备完成事件 */
  STREAM_VOD_COMPLETE: 'STREAM_VOD_COMPLETE',
  /** 撤销重做事件 */
  UNDO_STEP_CHANGE: 'UNDO_STEP_CHANGE',

  /** socket相关事件 */
  // 消息链接成功
  WS_ONLINE: 'WS_ONLINE',
  // 消息链接断开
  WS_OFFLINE: 'WS_OFFLINE',
  // 消息链接断开(与 WS_OFFLINE 差不多，但是会返回断开原因)
  WS_DISCONNECT: 'WS_DISCONNECT',
  // 消息链接重试
  WS_RECONNECT_ATTEMPT: 'WS_RECONNECT_ATTEMPT'
};

export const SDK_ERROR_CODE = {};

export const SDK_ERROR_MESSAGE = {};

export const SDK_CLIENT_TYPE = {
  /** PC网页浏览器 */
  PC_WEB: 'pc_browser',
  /**  h5网页浏览器 */
  H5_WEB: 'h5_browser',
  /** 安卓手机应用 */
  ANDROID: 'android',
  /** 苹果手机应用 */
  IOS: 'ios',
  /** 桌面客户端 */
  DESKTOP: 'desktop',
  /** 微信内置浏览器 */
  WECHAT_BROWSER: 'wechat_browser',
  /** 微信小程序 */
  WECHAT_APPLET: 'wechat_applet'
};

export const SDK_PLAY_MODE = {
  /** 互动 0延迟模式 */
  INTERACT: 'interact',
  /** FLV低延迟模式 */
  FLV: 'flv',
  /** hls 高延迟模式 */
  HLS: 'hls'
};

export const DELAY = {
  [`${SDK_CLIENT_TYPE.PC_WEB}_${SDK_PLAY_MODE.INTERACT}`]: 100,
  [`${SDK_CLIENT_TYPE.PC_WEB}_${SDK_PLAY_MODE.FLV}`]: 5 * 1000,
  [`${SDK_CLIENT_TYPE.PC_WEB}_${SDK_PLAY_MODE.HLS}`]: 10 * 1000,
  [`${SDK_CLIENT_TYPE.H5_WEB}_${SDK_PLAY_MODE.INTERACT}`]: 100,
  [`${SDK_CLIENT_TYPE.H5_WEB}_${SDK_PLAY_MODE.FLV}`]: 5 * 1000,
  [`${SDK_CLIENT_TYPE.H5_WEB}_${SDK_PLAY_MODE.HLS}`]: 10 * 1000
};

export const INNER_EVENT = {};

export const OPERATE_TYPE = {
  /** 创建容器 */
  CREATE_CONTAINER: 'create',
  /** 删除容器 */
  DELETE_CONTAINER: 'destroy',
  /** 选择容器 */
  SELECT_CONTAINER: 'active',
  /** 观看端演示状态开 */
  SWITCH_ON: 'switchon',
  /** 观看端演示状态关 */
  SWITCH_OFF: 'switchoff',
  /** 重置容器信息 */
  RESET_CONTAINER: 'reset'
};
/** 自定义cuepoint.msg 文件模式下 文档切片的最少间隔时间和播放步长 */
export const VOD = {
  UPDATE_TIME: 0.25,
  PART_SPACING: 15
};
/** 强制本实例使用 静/动 态 演示文档，目前代码只实现了静态，动态延后实现 */
export const FORCE_DOC_TYPE = {
  DYNAMIC: 1,
  STATIC: 2
};

export const VERSION = process.env.VERSION;
